/** @format */

const NavbarTranslations = {
  en: {
    'Sharing.label': 'Share!',
    'Sharing.title': 'WeMi is',
    'Sharing.title1': 'sharing',
    'Sharing.description':
      'The WeMi platform offers the possibility to all its users to share their needs or the services booked with the purpose of ',
    'Sharing.description1': 'create buying groups',
    'Sharing.description2': 'who can',
    'Sharing.description3': 'get the expected services at much more advantageous costs ',
    'Sharing.description4': 'for all',
    'Sharing.button': 'More info',
  },
  it: {
    'Sharing.label': 'Condividere!',
    'Sharing.title': 'WeMi è',
    'Sharing.title1': 'condivisione',
    'Sharing.description':
      'La piattaforma WeMi offre la possibilità a tutti i suoi utenti di condividere tra gli iscritti le proprie esigenze o i servizi prenotati con il fine di ',
    'Sharing.description1': 'creare dei gruppi di acquisto',
    'Sharing.description2': 'che possano ',
    'Sharing.description3': 'ottenere i servizi attesi a costi molto più vantaggiosi ',
    'Sharing.description4': 'per tutti',
    'Sharing.button': 'Approfondisci',
  },
};

export default NavbarTranslations;
